import { useState } from "react";
import { Hero } from "../components/home/Hero";
import { ColorSuite } from "../components/home/ColorSuite";
import { Showroom } from "../components/home/Showroom";
import { FeaturesBento } from "../components/home/FeaturesBento";
import { WearItYourWay } from "../components/home/WearItYourWay";
import { AngleViewer } from "../components/home/AngleViewer";
import { EmblemSection } from "../components/home/EmblemSection";
import { Reviews } from "../components/home/Reviews";
import { ComingSoon } from "../components/home/ComingSoon";
import { Marquee } from "../components/site/Marquee";
import { Newsletter } from "../components/site/Newsletter";
import { QuickView } from "../components/site/QuickView";

export default function Home() {
  const [qv, setQv] = useState(null);
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <ColorSuite onQuickView={setQv} />
      <Showroom />
      <FeaturesBento />
      <WearItYourWay />
      <AngleViewer />
      <EmblemSection />
      <ComingSoon />
      <Reviews />
      <Newsletter />
      <QuickView colorId={qv} onClose={() => setQv(null)} />
    </div>
  );
}
